var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 210.713,91.804 238,91.804 238,47.013 210.713,47.013  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 55.582,
    y1: 73.059,
    x2: 18,
    y2: 73.059
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M155.572,160.35c0,0-1.773-4.764-7.808-4.617l-14.828,0.402c0,0-6.772-15.039-9.581-25.31h0.012 c-0.014-0.048-0.032-0.092-0.046-0.135c-0.014-0.044-0.028-0.092-0.034-0.127h-0.012c-3.641-10.009-6.798-26.193-6.798-26.193 l12.341-8.235c5.015-3.368,3.71-8.279,3.71-8.279l-2.853-25.712c-0.627-4.362-3.67-5.17-3.67-5.17 c-3.571-1.65-11.065-0.039-18.912,2.72c-7.848,2.756-14.96,8.804-14.96,8.804c-9.778,27.887,4.595,67.079,5.549,70.344 c1.465,4.08,12.011,43.511,36.088,60.633c0,0,9.578,0.779,17.302-1.443c7.724-2.227,15.041-5.293,17.003-8.705 c0,0,2.022-2.413,0.012-6.338L155.572,160.35z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 55.582,
    y1: 126.157,
    x2: 18,
    y2: 126.157
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M34.755,199.658v13.997c0,11.198,9.162,20.36,20.36,20.36h134.309c11.198,0,20.36-9.162,20.36-20.36V42.345 c0-11.198-9.162-20.36-20.36-20.36H55.114c-11.198,0-20.36,9.162-20.36,20.36v30.794V199.658z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 210.598,149.622 237.885,149.622 237.885,111.519 210.713,111.519  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 210.598,207.305 237.885,207.305 237.885,169.202 209.783,169.202  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 55.582,
    y1: 180.01,
    x2: 18,
    y2: 180.01
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a1db81b93ed21825dbf33cc5056af5b9.svg";
export { ForwardRef as ReactComponent };